// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutReviewAndSubmitPaymentDetailsStyles } from "@flip/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { color, xScreen } from "@flip/XDL/Utilities";
import { css } from "styled-components";

checkoutReviewAndSubmitPaymentDetailsStyles.poNumberText = {
    cssOverrides: {
        formField: css`
            max-width: 430px;
            margin-left: auto;
            padding: 18px 16px 16px 16px;
            border: 1px solid ${color("common.border")};
            border-radius: 8px;
            background: ${color("secondary.main")};

            & > label {
                font-weight: ${fontConfig.weight.bold};
            }

            ${xScreen("lt", "md")} {
                max-width: none;
            }
        `,
    },
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        align-self: flex-end;
    `,
};
